<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col">
          <h6>LISTADO DE USUARIOS REGISTRADOS EN EL SISTEMA</h6>
        </div>
        <div class="col">
          <button class="btn bg-gradient-success float-end" @click="$router.push('/create-user')"> Crear nuevo usuario</button>
          <button v-if="$userCan('administrator')" class="btn bg-gradient-danger float-end me-2" @click="deactivateAll"> Desactivar todos</button>
        </div>
      </div>
    </div>
    <div class="card-body px-4">
        <div class="row justify-content-end">
          <div class="col-lg-4 col-md-6 col-sm-12">
            <input type="text" class="form-control" placeholder="Buscar por nombre, email o identificacion" v-model="pagination.search" @keyup="manualSearch">
          </div>
          <div class="col-lg-2 col-md-2 col-sm-12">
            <select name="per_page" id="per_page" v-model="pagination.limit" class="form-control" @click="reloadPaginate(1)">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </select>
          </div>
        </div>
      <div class="table-responsive">
        <table class="table table-bordered table-striped table-sm">
          <thead>
          <tr>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Name</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Telefono</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Identificacion</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
            <th v-if="$userCan('administrator')" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Agente</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Opciones</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, key) in arrayUsers" :key="key">
            <td>
              <p class="text-uppercase text-xs font-weight-bold mb-0">{{item.name}}</p>
              <p class="text-xs text-secondary mb-0">{{item.email}}</p>
            </td>
            <td>
              <p class="text-uppercase text-xs font-weight-bold mb-0">{{item.phone}}</p>
            </td>
            <td>
              <p class="text-uppercase text-xs font-weight-bold mb-0">{{item.identification}}</p>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{item.status?'ACTIVO':'INACTIVO'}}</p>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{$filters.formatDate(item.created_at)}}</p>
            </td>
            <td v-if="$userCan('administrator')">
              <select class="form-control form-control-sm" v-model="item.agent" @change="assignAgent(item)">
                <option :value="null">Sin asignar</option>
                <option v-for="(a, k) in arrayAgents" :key="k" :value="a._id">{{a.name}}</option>
              </select>
            </td>
            <td>
              <button class="btn btn-outline-success btn-sm mb-0 me-2" @click="viewDetail(item._id)">ver</button>
              <button class="btn btn-outline-warning btn-sm mb-0" @click="toggleStatus(item)">Cambiar estado</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
        <div class="d-flex justify-content-between">
          <div>
            <p class="text-xs font-weight-bold mb-0">total rows: {{pagination.totalRows}}</p>
          </div>
          <div>
            <v-pagination
                v-model="pagination.page"
                :pages="pagination.pages"
                :range-size="1"
                active-color="#DCEDFF"
                @update:modelValue="reloadPaginate"
            />
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import {get, post} from "@/utils/httpRequest";

export default {
  data: () => ({
    arrayUsers: [],
    arrayAgents: [],
    pagination: {
      searchTimer: null,
      page: 1,
      pages: 0,
      limit: 20,
      search: '',
      totalRows: 0
    }
  }),
  mounted() {
    this.getData();
    if(this.$userCan('administrator')){
      this.getAgents();
    }
  },
  methods: {
    async getAgents() {
      try {
        const {data} = await get('users/list-agents');
        this.arrayAgents = data;
      } catch (error) {
        console.error(error);
      }
    },
    async assignAgent(item) {
      await post('users/assign-agent', {_id: item._id, agent: item.agent || null});
      this.$swal({
        html: 'Agente asignado correctamente',
        icon: 'success',
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: false,
      });
    },
    async deactivateAll() {
      const confirm = await this.$swal({
        title: '¿Desactivar TODOS los leads/clientes?',
        text: 'Esta accion desactiva a todos los clientes del sistema',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, desactivar todos',
        cancelButtonText: 'Cancelar',
      });
      if(!confirm.isConfirmed) return;
      const {data} = await post('users/deactivate-all', {});
      if(data && data.statusCode === 200){
        this.$swal({
          html: `${data.updated} clientes desactivados`,
          icon: 'success',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
        await this.getData();
      }
    },
    reloadPaginate(page){
      this.pagination.page = page
      this.getData()
    },
    manualSearch(){
      clearTimeout(this.pagination.searchTimer);
      this.pagination.searchTimer = setTimeout(() => {
        this.reloadPaginate(1)
      }, 2000);
    },
    viewDetail(_id) {
      console.log(_id)
      this.$router.push({ name: 'detail-user', query: { id: _id } });
    },
    async toggleStatus(item) {
      try {
        const {data} = await post('users/toggle-status', {_id: item._id});
        if(data && data.statusCode === 200){
          item.status = data.status;
          this.$swal({
            html: `Estado actualizado a ${data.status ? 'ACTIVO' : 'INACTIVO'}`,
            icon: 'success',
            timer: 1500,
            showCancelButton: false,
            showConfirmButton: false,
          });
        }
      } catch (error) {
        console.error(error);
        this.$swal({
          html: 'No se pudo actualizar el estado',
          icon: 'error',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    },
    async getData() {
      try {
        const {data} = await get(`users/find-all?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${this.pagination.search}`);
        this.arrayUsers = data.docs
        this.pagination.totalRows = data.count
        this.pagination.page = data.page
        this.pagination.pages = data.pages
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style scoped>
</style>
